import axiosInstance from './axios';
import { ReferralParams, ReferralResponse } from 'types/referral';

export const referralService = {
  createCampaign: async (payload: { name: string; code: string }) => {
    const response = await axiosInstance.post('/client/referral/campaigns', payload);
    return response.data;
  },
  getCampaigns: async () => {
    const response = await axiosInstance.get('/client/referral/campaigns');
    return response.data;
  },
  getReferrals: async () => {
    const response = await axiosInstance.get('/client/referral/referrals');
    return response.data;
  },
  getUserReferrals: async (userId: string, params: ReferralParams): Promise<ReferralResponse> => {
    const response = await axiosInstance.get(`/admin/referral/users/${userId}/referrals`, {
      params,
    });
    return response.data;
  },
  addUserReferral: async (
    userId: string | number,
    payload: { childUserId: number; campaignId: number },
  ) => {
    const response = await axiosInstance.post(`/admin/referral/users/${userId}/referrals`, payload);
    return response.data;
  },
};
